import { useEffect, useRef, useState } from "react";

/**
 * Acompanha o ponteiro do mouse e devolve um deslocamento normalizado (-1..1) da pupila
 * em relação ao centro do elemento referenciado — é o que dá o efeito do mascote
 * "seguindo com os olhos" o que a pessoa está fazendo na tela. Em telas touch, sem
 * mousemove, os olhos simplesmente ficam centralizados.
 */
export function useMascotLook(maxDistance = 240) {
  const ref = useRef<HTMLDivElement>(null);
  const [look, setLook] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMove = (e: MouseEvent) => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy) || 1;
      const clamped = Math.min(dist, maxDistance) / maxDistance;
      setLook({ x: (dx / dist) * clamped, y: (dy / dist) * clamped });
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, [maxDistance]);

  return { ref, look };
}
